import { SubmissionError } from 'redux-form';
import { showErrorNotification } from '@nextiva/engagement-ui';

import { openApplicationErrorModal } from 'actions/appActions';
import { isEmpty } from 'lodash';
import { getApiErrorList, isForbiddenRejection, isUnautorizedRejection } from '../../api/utils/apiUtils';
import { getErrorType } from '../../taker/api/utils/takerApiUtils';
import { setAccessErrorType } from '../appActions';
import { toLogin } from '../../utils/authUrlUtils';
import { NO_LICENSE, NO_PERMISSION } from '../../constants/ErrorTypes';

// @todo: replace all usages with handleApiErrors and remove this @apavlosiuk
export const handleApiErrorsLegacy = (error = {}, dispatch) => {
  const { submissionError, errorMessages, rejection } = error;
  if (isForbiddenRejection(rejection)) {
    /* to handle case when tyk rejects with an error (https://jira.nextiva.xyz/browse/SRV-803) @dkaminskiy */
    if (
      rejection.response.data.error ===
      'Forbidden - user id not found or corporate account number missing or unmatched'
    ) {
      dispatch(setAccessErrorType(NO_LICENSE));
      return Promise.reject(rejection);
    }

    const errorList = getApiErrorList(error);
    if (!isEmpty(errorList)) {
      const errorType = getErrorType(errorList[0]);
      dispatch(setAccessErrorType(errorType));
    } else {
      dispatch(setAccessErrorType(NO_PERMISSION));
    }
    return Promise.reject(rejection);
  }

  if (isUnautorizedRejection(rejection)) {
    toLogin();
    return Promise.reject(rejection);
  }

  if (submissionError) {
    throw new SubmissionError(submissionError);
  }

  if (error.isClientError) {
    errorMessages.forEach((message) => dispatch(showErrorNotification(message)));
    return Promise.reject(error);
  }

  dispatch(
    openApplicationErrorModal({
      list: errorMessages,
    }),
  );

  return Promise.reject(error);
};

export const handleApiErrors = (error = {}) => (dispatch) => handleApiErrorsLegacy(error, dispatch);

export const parsedData = (blockData, action) => {
  if (blockData.logic && blockData.logic.logicList) {
    const block = {
      ...blockData,
      logic: {
        ...blockData.logic,
        logicList: blockData.logic.logicList.map((item) => {
          const data = {
            ...item,
            ...(action === 'show' && {
              result: {
                action,
                client_uuid: item.questionToJumpUuid,
              },
            }),
          };
          if (action === 'show') delete data.questionToJumpUuid;
          if (action === 'skip') delete data.result;
          return data;
        }),
      },
    };
    delete block.logic.action;
    return block;
  }
  return blockData;
};
